export const GUEST_READ_ONLY_TITLE = 'Misafirler Sadece Bakabilir 👀';

export const GUEST_READ_ONLY_MESSAGE =
  'Yorum yazmak, mesaj göndermek veya ilan vermek için ücretsiz kayıt olarak Annedaş topluluğuna katılmalısın.';
